import * as React from 'react';
import { st, classes } from './AvatarGroup.st.css';
import { Avatar, AvatarSize } from '../Avatar';
import { AvatarGroupTextButton } from './AvatarGroupTextButton';
import { TextButton } from '../TextButton';
import { AvatarGroupSize, } from './types';
import { AvatarGroupBase } from './AvatarGroup.base';
import { DATA_HOOKS } from './constants';
/** The Avatar group is made up of a group of avatars and an optional text link. Content in text link can be customized to the product's intent. */
export class AvatarGroup extends React.Component {
    constructor() {
        super(...arguments);
        this.getTextButton = () => {
            const { children } = this.props;
            const textButton = React.Children.toArray(children).find((child) => React.isValidElement(child) &&
                (child.type === TextButton || child.type === AvatarGroupTextButton));
            if (textButton) {
                return React.cloneElement(textButton, {
                    className: `${textButton.props.className || ''} ${classes.textButton}`,
                    'data-hook': DATA_HOOKS.textButton,
                });
            }
            return undefined;
        };
        this.renderAvatar = (renderProps) => {
            return (React.createElement(Avatar, { size: AvatarSize[this.props.size] || AvatarSize.medium, className: classes.avatar, ...renderProps }));
        };
    }
    render() {
        const { items, size, maxAmount, className, showHiddenAvatarCount } = this.props;
        const textButton = this.getTextButton();
        return (React.createElement("div", { className: st(classes.root, { size }, className), "data-hook": this.props['data-hook'] },
            React.createElement(AvatarGroupBase, { items: items, className: classes.avatars, renderHiddenAvatarCount: showHiddenAvatarCount ? this.renderAvatar : undefined, avatarContainerClassName: classes.avatarContainer, maxAmount: maxAmount, renderAvatar: this.renderAvatar }),
            textButton ? (React.createElement("div", { className: classes.textButtonContainer }, textButton)) : null));
    }
}
AvatarGroup.displayName = 'AvatarGroup';
AvatarGroup.defaultProps = {
    items: [],
    maxAmount: 5,
    size: AvatarGroupSize.medium,
    showHiddenAvatarCount: false,
};
AvatarGroup.TextButton = AvatarGroupTextButton;
//# sourceMappingURL=AvatarGroup.js.map